import cardFactory from '@/descriptors/cards';
import objectSubsetSelector from '@/utils/object-subset-selector';
import { card, cardDetailed, cardImage } from './card-models';

const generateConfigForCardType = (cardType, wrapper) => {
  const result = [];
  Object.keys(cardType)
    .forEach(key => {
      result.push(wrapper(cardType[key], key));
    });
  return result;
};

const getWrapper = model => {
  if (model === 'detailed') {
    return cardDetailed;
  }

  if (model === 'image') {
    return cardImage;
  }

  return card;
};

export const generateConfig = (count, typeA, typeB, shuffle) => {
  const cardTypes = cardFactory();

  const seed = Math.random();
  const shuffler = a => shuffle(a, seed);

  const cardSubsetA = objectSubsetSelector(cardTypes[typeA].cards, count, shuffler);
  const cardSubsetB = objectSubsetSelector(cardTypes[typeB].cards, count, shuffler);

  const cardsA = generateConfigForCardType(cardSubsetA, getWrapper(cardTypes[typeA].model));
  const cardsB = generateConfigForCardType(cardSubsetB, getWrapper(cardTypes[typeB].model));

  return [].concat(cardsA, cardsB);
};
